import React, { Component } from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { MDCTopAppBar } from '@material/top-app-bar';

export class TopBar extends Component {
    constructor(props) {
        super(props);
        this.topBarRef = React.createRef();
    }

    componentDidMount() {
        // Note: we need to instanciate MDCTopAppBar here, since it's required by Material Design
        //eslint-disable-next-line sonarjs/constructor-for-side-effects
        new MDCTopAppBar(this.topBarRef.current);
    }

    getTopBarClassFromType(type) {
        if (type === "fixed") {
            return "mdc-top-app-bar mdc-top-app-bar--fixed";
        }
        if (type === "short") {
            return "mdc-top-app-bar mdc-top-app-bar--short";
        }
        if (type === "short-closed") {
            return "mdc-top-app-bar mdc-top-app-bar--short mdc-top-app-bar--short-collasped";
        }
        if (type === "prominent") {
            return "mdc-top-app-bar mdc-top-app-bar--prominent";
        }
        if (type === "dense") {
            return "mdc-top-app-bar mdc-top-app-bar--dense";
        }
        return "mdc-top-app-bar";
    }

    render() {
        const topBarClass = this.getTopBarClassFromType(this.props.topBarType);
        return(
            <header id="rese-app-bar" className={cIf(["rese-top-app-bar", topBarClass])} ref={this.topBarRef}>
                {this.props.menuComponent}
                <div className="mdc-top-app-bar__row">
                    {this.props.children}
                </div>
                <div className="header-footer-separator" />
            </header>
        );
    }
}
TopBar.propTypes = {
    menuComponent: PT.object, // Using this for now, to avoid large waste of time. Needs to think about this later.
    topBarType: PT.oneOf(["classic", "fixed", "short", "short-closed", "prominent", "dense"])
};
TopBar.defaultProps = {
    topBarType: "fixed"
};

export class TopBarLogo extends Component {
    render() {
        return (
            <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <a href={this.props.action} className="full-logo">
                    <img
                        className="logo-reservatech"
                        src={this.props.paths.fullLogo}
                        alt="logo-reservatech"
                    />
                </a>
                <a href={this.props.action} className="small-logo">
                    <img
                        className="logo-reservatech"
                        src={this.props.paths.smallLogo}
                        alt="small-logo-reservatech"
                    />
                </a>
            </section>
        );
    }
}
TopBarLogo.propTypes = {
    action: PT.string,
    paths: PT.shape({
        fullLogo: PT.string,
        smallLogo: PT.string
    })
};

export class TopBarContent extends Component {
    render() {
        return (
            <section className="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                {this.props.children}
            </section>
        );
    }
}
TopBarContent.propTypes = {
};

// This represents 1 thing in the header. 1 icon, 1 link...
export function TopBarItem({ children, classNames }) {
    return (
        <div className={cIf(["rese-top-app-bar-item", classNames ])}>
            {children}
        </div>
    );
}
TopBarItem.propTypes = {
    classNames: PT.string
};

export function TopBarVerticalSeparator({ classNames }) {
    return <TopBarItem classNames={cIf([ classNames ])}>
        <div className="top-app-bar-vertical-separator"></div>    
    </TopBarItem>;
}
TopBarVerticalSeparator.propTypes = {
    classNames: PT.string
};


export class TopBarIconTextLink extends Component {
    render() {
        return <TopBarItem classNames={cIf([ this.props.classNames ])}>
            <a href={this.props.href}>
                <i className={cIf(["topbar-autolabel-icon", this.props.icon.classNames])}>{this.props.icon.iconName}</i>
                <span className="topbar-autolabel-text rese-top-app-bar-title mdc-top-app-bar__title">{this.props.label}</span>
            </a>
        </TopBarItem>;
    }
}
TopBarIconTextLink.propTypes = {
    label: PT.string,
    href: PT.string,
    icon: PT.shape({
        classNames: PT.string,
        iconName: PT.string
    }),
    classNames: PT.string
};



export function TopBarMenuIcon({ classNames, containerClass, iconClass, iconName }) {

    return <TopBarItem classNames={cIf([ classNames ])}>
        <div className={containerClass}>
            <i className={iconClass}>{iconName}</i>
        </div>
    </TopBarItem>;
}
TopBarMenuIcon.propTypes = {
    containerClass: PT.string,
    iconClass: PT.string,
    iconName: PT.string,
    classNames: PT.string
};
